export default __webpack_public_path__ + "static/media/Cosmos.44a61547.svg";